"use client";

import React from "react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowRight } from "lucide-react";
export default function TheGoldenYearsStory() {
  const {
    ref: leftRef,
    isVisible: isLeftVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: rightRef,
    isVisible: isRightVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="139531" id="supporting-the-supporters" className="relative bg-background pt-24 pb-32 lg:pt-32 lg:pb-48 overflow-hidden font-sans">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          
          {}
          <div ref={leftRef} className={`lg:col-span-7 relative transition-all duration-1000 ease-out ${isLeftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <div className="relative rounded-xl overflow-hidden shadow-xl group">
              {}
              <div className="absolute inset-0 z-10 pointer-events-none rounded-xl shadow-[inset_0_0_80px_var(--color-secondary)] opacity-30 mix-blend-multiply transition-opacity duration-700 group-hover:opacity-50"></div>
              <div className="absolute inset-0 z-10 pointer-events-none rounded-xl shadow-[inset_0_0_40px_var(--color-secondary)] opacity-20"></div>
              
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1605152/img/caregiver_hands_support.png" alt="Compassionate support for prostate cancer caregivers" className="w-full h-auto object-cover aspect-[4/3] lg:aspect-[16/11] transform transition-transform duration-1000 group-hover:scale-105" />
            </div>
            
            {}
            <div className="absolute -top-12 -left-12 w-64 h-64 bg-secondary/10 rounded-full blur-3xl -z-10 pointer-events-none"></div>
            <div className="absolute -bottom-12 -right-12 w-80 h-80 bg-accent/5 rounded-full blur-3xl -z-10 pointer-events-none"></div>
          </div>

          {}
          <div ref={rightRef} className={`lg:col-span-5 flex flex-col items-start transition-all duration-1000 delay-200 ease-out ${isRightVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
            <Badge variant="default" className="rounded-full px-4 py-1.5 text-sm tracking-wider font-semibold mb-6 shadow-sm bg-secondary text-secondary-foreground">
              FAMILY SUPPORT
            </Badge>
            
            <h2 className="text-4xl md:text-5xl font-serif font-bold text-foreground mb-6 leading-tight tracking-tight">
              Empowering those who <span className="text-secondary italic">care</span> most.
            </h2>
            
            <p className="text-lg text-foreground/80 leading-[1.6] mb-8 font-medium">
              Caring for a loved one with prostate cancer is a journey of its own. I provide dedicated guidance for spouses and family members, translating complex clinical data into clear language and offering the practical support needed to navigate every decision with absolute confidence.
            </p>
            
            <Button size="lg" className="rounded-full px-8 py-6 text-base font-semibold group bg-accent hover:bg-accent/90 text-white shadow-lg shadow-accent/20" asChild>
              
            </Button>
          </div>

        </div>
      </div>

      {}
      <div className="absolute bottom-0 left-0 w-full overflow-hidden leading-[0] pointer-events-none z-0">
        <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none" className="relative block w-full h-[80px] md:h-[120px] lg:h-[160px]">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V120H0V0C73.8,30.6,150.8,55.3,228.3,67.5,259.4,72.4,290.5,74.2,321.39,56.44Z" className="fill-muted/50"></path>
        </svg>
      </div>
    </section>;
}